// to render a single input
import React from 'react';
import TextField from '@material-ui/core/TextField';

          
const EmailFormField = ({input, label, meta:{error, touched} }) => {

    return (<>
            <div className="form-group">
                <TextField {...input} label={label} 
                        multiline={input?.name !== 'message' ? false : true} 
                        style={{width: '100%'}}/>
            </div>
            <div style={{marginBottom: '10px', color: 'red'}} >
                {touched && error}
            </div>
        </>
    );
}

export default EmailFormField;